import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type IsTemplateCardFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'isTemplate'>
);

export const IsTemplateCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IsTemplateCard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseIsTemplateCardFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      IsTemplateCardFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseIsTemplateCardFragmentResult
  extends Omit<Apollo.UseFragmentResult<IsTemplateCardFragment>, 'data'> {
  data?: IsTemplateCardFragment;
}

export const useIsTemplateCardFragment = ({
  from,
  returnPartialData,
  ...options
}: UseIsTemplateCardFragmentOptions): UseIsTemplateCardFragmentResult => {
  const result = Apollo.useFragment<IsTemplateCardFragment>({
    ...options,
    fragment: IsTemplateCardFragmentDoc,
    fragmentName: 'IsTemplateCard',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as IsTemplateCardFragment };
};
